import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'state/store';

export type ElectricVehicleState = {
  data: {
    electricVehicle: boolean | null;
  };
};
export const initialState: ElectricVehicleState = {
  data: {
    electricVehicle: null
  }
};

export const slice = createSlice({
  name: 'electricVehicle',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setElectricVehicle: (state, { payload }) => {
      state.data.electricVehicle = payload;
    }
  }
});

export const { setInitialState, setElectricVehicle } = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectSliceData = (state: RootState) => selectSlice(state).data;
export const selectElectricVehicle = (state: RootState) =>
  selectSliceData(state).electricVehicle;

export default slice.reducer;
